import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectSystemConfig,
  selectIsNetworkConnected,
  selectSocketConnected,
  selectDeviceConfigEntries,
  selectDevicesConfigs,
  selectRawSensorData,
  selectSolutionType,
  selectCustomersList,
  selectSelectedSystems,
  selectSelectedMapSystems,
  selectSelectedSensorSite,
  selectEditViewCustomerId,
  selectEditViewSiteName,
  selectEditViewSelectedDeviceId,
  selectEditViewEnabled,
  selectCreateCustomerView,
  selectCreateDeviceView,
  makeSelectDevicesListForUI,
} from "../../src/Dashboard/ducks/selectors";

// ─── System-keyed selectors (take systemId as argument) ──────────────────────

export const useCloudSystemConfig = (systemId) =>
  useSelector((state) => selectSystemConfig(state, systemId));

export const useCloudIsNetworkConnected = (systemId) =>
  useSelector((state) => selectIsNetworkConnected(state, systemId));

export const useCloudSocketConnected = (systemId) =>
  useSelector((state) => selectSocketConnected(state, systemId));

export const useCloudDevicesList = (systemId) => {
  const selectDevicesListForUI = useMemo(makeSelectDevicesListForUI, []);
  return useSelector((state) => selectDevicesListForUI(state, systemId));
};

export const useCloudDeviceConfigEntries = (systemId) =>
  useSelector((state) => selectDeviceConfigEntries(state, systemId));

export const useCloudDevicesConfigs = (systemId) =>
  useSelector((state) => selectDevicesConfigs(state, systemId));

export const useCloudRawSensorData = (systemId) =>
  useSelector((state) => selectRawSensorData(state, systemId));

export const useCloudSolutionType = (systemId) =>
  useSelector((state) => selectSolutionType(state, systemId));

// ─── Customer selectors (no systemId needed) ────────────────────────────────

export const useCustomersList = () =>
  useSelector(selectCustomersList);

export const useSelectedSystems = () =>
  useSelector(selectSelectedSystems);

export const useSelectedMapSystems = () =>
  useSelector(selectSelectedMapSystems);

export const useSelectedSensorSite = () =>
  useSelector(selectSelectedSensorSite);

export const useEditViewCustomerId = () =>
  useSelector(selectEditViewCustomerId);

export const useEditViewSiteName = () =>
  useSelector(selectEditViewSiteName);

export const useEditViewSelectedDeviceId = () =>
  useSelector(selectEditViewSelectedDeviceId);

export const useEditViewEnabled = () =>
  useSelector(selectEditViewEnabled);

export const useCreateCustomerView = () =>
  useSelector(selectCreateCustomerView);

export const useCreateDeviceView = () =>
  useSelector(selectCreateDeviceView);
